// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WS8n","icon":"styles_icon__uA357"};